import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setError, setErrorReset } from '../../store/error.js';

const BaseLink = ({ className, to, children }) => {
    const dispatch = useDispatch();

    const resetError = () => {
        dispatch(setErrorReset({ reset: false, boundary: false }));
        dispatch(setError({ status: false, errorMessages: {} }));
    };

    return (
        <Link onClick={resetError} className={className} to={to}>
            {children}
        </Link>
    );
};

export default BaseLink;
